import { Navigate, Outlet, RouteObject } from "react-router";
import { OfferIndexPage } from "./_components/offer-index-page";
import { OfferRoute } from "./[offerId]/offer-route";
import { OfferDataRoute } from "./[offerId]/data/offer-data-route";
import { OfferFilesRoute } from "./[offerId]/files/offer-files-route";
import { OfferPositionsRoute } from "./[offerId]/positions/offer-positions-route";

// The contracts attached to the offer are edited on its positions page,
// see OfferPositionsPage.
export const wrhOffersRoutes: RouteObject[] = [
  {
    index: true,
    element: <OfferIndexPage />,
  },
  {
    path: ":offerId",
    element: <Outlet />,
    children: [
      {
        element: <OfferRoute />,
        children: [
          {
            index: true,
            element: <Navigate to="data" replace />,
          },
          {
            path: "data",
            element: <OfferDataRoute />,
          },
          {
            path: "files",
            element: <OfferFilesRoute />,
          },
          {
            path: "positions",
            element: <OfferPositionsRoute />,
          },
        ],
      },
    ],
  },
];
